import React, { useContext } from 'react'

import { DataContext } from './DataContext'
import NoDataComponent from '../../../elem/table/client/NoDataComponent'
import TableContent from '../../../elem/table/client/TableContent'
import parseColumns from '../../../../utils/table/parseColumns'
import withConfig from '../../../wrappers/withConfig'

export default withConfig(({ config }) => {
    const { detailData, filterData, visibleTab, isLoading } = useContext(DataContext)
    const { ID_COLUMN, EXPLORER_LINK_COLUMN } = config
    if (
            detailData &&
            detailData.mit &&
            filterData &&
            filterData.mit &&
            visibleTab === 'mit'
    ) {
        const formFields = filterData.mit
        
         const mitDetailsData = detailData.mit       
        const columns = parseColumns(mitDetailsData, formFields, EXPLORER_LINK_COLUMN, ID_COLUMN)
        return (
            <div className="is-size-7">
                <NoDataComponent data={mitDetailsData} isLoading={isLoading}/>
                <TableContent
                    name="mitDetails"
                    columns={columns}
                    data={mitDetailsData}
                    containerClass={'detailTableWrapper'}
                    loading={isLoading}
                    initialSort={'StartTime'}
                    initialSortDesc={true}
                />
            </div>
        )

    } else {
        return null
    }
})